import { render, staticRenderFns } from "./MessagesSettings.vue?vue&type=template&id=e63ba894&"
import script from "./MessagesSettings.vue?vue&type=script&lang=ts&"
export * from "./MessagesSettings.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesSettings.vue?vue&type=style&index=0&id=e63ba894&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports